<template>
  <main class="memo-page mt-8 flex flex-1 flex-col min-w-0 mr-10">
    <div class="main-title flex justify-between mb-2">
      <div class="flex flex-col">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Memos</h1>
      <Breadcrumb :page="companyID"/>

      </div>

      <div class="flex">
        <div class="min-w-[130px] max-w-[200px] w-auto text-right relative">
        <Menu>
          <MenuButton>
            <div class="flex items-center bg-black text-white py-[10px] px-[14px] font-medium rounded-[4px]">Actions
              <span class="ml-[10px]">
                <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.9998 6.33398C3.82961 6.33313 3.66174 6.29439 3.50838 6.22059C3.35501 6.14679 3.22 6.03978 3.11314 5.90732L0.306469 2.50732C0.142465 2.30263 0.0392593 2.05599 0.00861339 1.7955C-0.0220325 1.53501 0.0211136 1.27115 0.133135 1.03398C0.223988 0.827869 0.372251 0.65226 0.560215 0.528133C0.748179 0.404006 0.9679 0.336606 1.19314 0.333984H6.80647C7.0317 0.336606 7.25143 0.404006 7.43939 0.528133C7.62735 0.65226 7.77561 0.827869 7.86647 1.03398C7.97849 1.27115 8.02164 1.53501 7.99099 1.7955C7.96035 2.05599 7.85714 2.30263 7.69314 2.50732L4.88647 5.90732C4.7796 6.03978 4.64459 6.14679 4.49123 6.22059C4.33786 6.29439 4.17 6.33313 3.9998 6.33398Z" fill="white"/>
                </svg>
              </span>
            </div>
          </MenuButton>
          <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-out"
            leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
          >
            <MenuItems class="flex absolute right-0 top-[50px] flex-col py-[4px] bg-white rounded-[4px] shadow-md z-[5000]">
              <MenuItem v-slot="{ active }">
                <span @click="onSubmit" :class='{ "bg-black text-white": active }' class="text-sm text-left py-2 px-6 cursor-pointer">Save memo</span>
              </MenuItem>
              <MenuItem v-slot="{ active }">
                <a :href="`${memoBaseUrl}/${memo.slug}`" target="_blank" :class='{ "bg-black text-white": active }' class="text-sm text-left py-2 px-6 cursor-pointer">View memo</a>
              </MenuItem>
              <MenuItem v-slot="{ active }" @click="createSharableLink(memo.slug)">
                <span :class='{ "bg-black text-white": active }' class="text-sm text-left py-2 px-6 cursor-pointer">Share memo</span>
              </MenuItem>
            </MenuItems>
          </transition>
        </Menu>
      </div>
        <!-- <button
          class="flex items-center border-[0.6px] border-blueLink2 rounded text-xs text-blueLink leading-[15.41px] font-medium font-Rubik px-4 py-3 mr-3"
          @click="createSharableLink(memo.slug)"
        >
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_176_9320)">
              <path
                d="M7.33333 1.83333C6.96514 1.83333 6.66667 1.53486 6.66667 1.16667C6.66667 0.798477 6.96514 0.5 7.33333 0.5H11.3333C11.5101 0.5 11.6797 0.570238 11.8047 0.695262C11.9298 0.820287 12 0.989856 12 1.16667L12 5.16667C12 5.53486 11.7015 5.83333 11.3333 5.83333C10.9651 5.83333 10.6667 5.53486 10.6667 5.16667L10.6667 2.77614L4.4714 8.9714C4.21106 9.23175 3.78894 9.23175 3.5286 8.9714C3.26825 8.71105 3.26825 8.28894 3.5286 8.0286L9.72386 1.83333H7.33333ZM0 3.16667C0 2.43029 0.596954 1.83333 1.33333 1.83333H4.66667C5.03486 1.83333 5.33333 2.13181 5.33333 2.5C5.33333 2.86819 5.03486 3.16667 4.66667 3.16667H1.33333V11.1667H9.33333V7.83333C9.33333 7.46514 9.63181 7.16667 10 7.16667C10.3682 7.16667 10.6667 7.46514 10.6667 7.83333V11.1667C10.6667 11.903 10.0697 12.5 9.33333 12.5H1.33333C0.596954 12.5 0 11.903 0 11.1667V3.16667Z"
                fill="#187CB4"
              />
            </g>
            <defs>
              <clipPath id="clip0_176_9320">
                <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          <span class="ml-2">Share memo</span>
        </button> -->
        <Modal v-show="data.modalOpen">
          <div class="bg-white rounded-[2px] py-[40px] px-[48px] relative w-[565px]">
            <div>
              <button @click.prevent="closeModal" class="close absolute right-[20px] top-[20px]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0D0D0D"/>
                </svg>
              </button>
              <h3 class="font-medium text-[20px] font-Rubik leading-[28px] tracking-[-2%] text-black mb-4">
                Share
              </h3>
              <div class="relative mt-4">
                <label for="memo-link" class="text-[14px] leading-[16.59px] font-normal mb-2">Memo Link</label>
                <div class="flex items-center relative px-[19px] mt-2 bg-faintGrey rounded-[4px]">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.19048 12.3453C6.37232 12.1639 6.61866 12.0621 6.87548 12.0621C7.1323 12.0621 7.37864 12.1639 7.56048 12.3453C7.65031 12.435 7.72158 12.5415 7.7702 12.6588C7.81882 12.7761 7.84385 12.9018 7.84385 13.0288C7.84385 13.1557 7.81882 13.2814 7.7702 13.3987C7.72158 13.516 7.65031 13.6226 7.56048 13.7123L5.50548 15.7643C5.32567 15.9437 5.18301 16.1569 5.08568 16.3915C4.98834 16.6262 4.93824 16.8777 4.93824 17.1318C4.93824 17.3858 4.98834 17.6374 5.08568 17.872C5.18301 18.1067 5.32567 18.3198 5.50548 18.4993C5.86916 18.862 6.36184 19.0657 6.87548 19.0657C7.38913 19.0657 7.88181 18.862 8.24548 18.4993L13.0395 13.7123C13.1293 13.6226 13.2006 13.516 13.2492 13.3987C13.2978 13.2814 13.3229 13.1557 13.3229 13.0288C13.3229 12.9018 13.2978 12.7761 13.2492 12.6588C13.2006 12.5415 13.1293 12.435 13.0395 12.3453C12.9495 12.2555 12.8781 12.1489 12.8294 12.0316C12.7807 11.9142 12.7556 11.7883 12.7556 11.6613C12.7556 11.5342 12.7807 11.4084 12.8294 11.291C12.8781 11.1736 12.9495 11.067 13.0395 10.9773C13.2213 10.7959 13.4677 10.6941 13.7245 10.6941C13.9813 10.6941 14.2276 10.7959 14.4095 10.9773C14.6793 11.2465 14.8933 11.5662 15.0394 11.9182C15.1854 12.2703 15.2606 12.6476 15.2606 13.0288C15.2606 13.4099 15.1854 13.7873 15.0394 14.1393C14.8933 14.4913 14.6793 14.8111 14.4095 15.0803L9.61448 19.8673C8.88726 20.593 7.90185 21.0005 6.87448 21.0005C5.84711 21.0005 4.8617 20.593 4.13448 19.8673C3.77485 19.5084 3.48954 19.0821 3.29487 18.6127C3.1002 18.1434 3 17.6403 3 17.1323C3 16.6242 3.1002 16.1211 3.29487 15.6518C3.48954 15.1825 3.77485 14.7562 4.13448 14.3973L6.19048 12.3443V12.3453ZM17.8105 11.6553C17.6286 11.8366 17.3823 11.9385 17.1255 11.9385C16.8687 11.9385 16.6223 11.8366 16.4405 11.6553C16.3506 11.5656 16.2794 11.459 16.2308 11.3417C16.1821 11.2244 16.1571 11.0987 16.1571 10.9718C16.1571 10.8448 16.1821 10.7191 16.2308 10.6018C16.2794 10.4845 16.3506 10.378 16.4405 10.2883L18.4955 8.23627C18.6753 8.05682 18.818 7.84366 18.9153 7.60901C19.0126 7.37435 19.0627 7.12281 19.0627 6.86877C19.0627 6.61473 19.0126 6.36318 18.9153 6.12853C18.818 5.89388 18.6753 5.68072 18.4955 5.50127C18.1318 5.13854 17.6391 4.93484 17.1255 4.93484C16.6118 4.93484 16.1192 5.13854 15.7555 5.50127L10.9625 10.2883C10.8726 10.378 10.8014 10.4845 10.7528 10.6018C10.7041 10.7191 10.6791 10.8448 10.6791 10.9718C10.6791 11.0987 10.7041 11.2244 10.7528 11.3417C10.8014 11.459 10.8726 11.5656 10.9625 11.6553C11.0525 11.745 11.1239 11.8516 11.1726 11.969C11.2213 12.0864 11.2464 12.2122 11.2464 12.3393C11.2464 12.4663 11.2213 12.5922 11.1726 12.7096C11.1239 12.8269 11.0525 12.9335 10.9625 13.0233C10.7806 13.2046 10.5343 13.3065 10.2775 13.3065C10.0207 13.3065 9.77432 13.2046 9.59248 13.0233C9.32269 12.7541 9.10864 12.4343 8.96259 12.0823C8.81655 11.7303 8.74137 11.3529 8.74137 10.9718C8.74137 10.5906 8.81655 10.2133 8.96259 9.86125C9.10864 9.50922 9.32269 9.18946 9.59248 8.92027L14.3875 4.13327C15.1147 3.40757 16.1001 3 17.1275 3C18.1549 3 19.1403 3.40757 19.8675 4.13327C20.2271 4.49217 20.5124 4.91848 20.7071 5.38779C20.9018 5.8571 21.002 6.36019 21.002 6.86827C21.002 7.37635 20.9018 7.87944 20.7071 8.34875C20.5124 8.81805 20.2271 9.24436 19.8675 9.60327L17.8105 11.6563V11.6553Z" fill="black"/>
                  </svg>
                  <div class="px-4 py-4 pr-[80px] text-[15px] leading-[17.78px] font-Rubik border-none placeholder-black text-black text-sm w-full bg-[transparent]">
                    {{data.slug}}
                  </div>
                  <button @click="copyToClipboard(data.slug)" class="bg-black border-none rounded-[4px] min-w-[80px] font-medium text-white text-sm text-center py-[11px] px-4 absolute right-1">
                    {{textCopied ? 'Copied' : 'Copy'}}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </Modal>
      </div>
    </div>
    <div class="flex flex-col pb-2 overflow-auto">
      <div class="left flex flex-col items-start w-full mb-6">
        <div class="flex items-center mb-[14px]">
          <h2 class="text-[24px] leading-[32px] tracking-[-2%] mr-4">
            {{ memo.title }}
          </h2>

          <div
            class="flex items-center justify-center flex-wrap w-[max-content]"
          >
            <div
              class="bg-faintGrey text-greyText text-[14px] leading-[20px] py-[6px] px-[12px] max-w-[max-content] min-w-[122.59px] mr-3 rounded-[4px]"
            >
              Industry: <span class="text-black">{{ memo.industry_type }}</span>
            </div>
            <div
              class="bg-faintGrey text-greyText text-[14px] leading-[20px] py-[6px] px-[12px] max-w-[max-content] min-w-[122.59px] mr-3 rounded-[4px]"
            >
              Business model: <span class="text-black">{{ memo.business_model }}</span>
            </div>
          </div>

        </div>
        <div class="flex items-center text-sm font-medium mb-4">
          <span class="h-8 w-8 mr-2">
            <img class="h-8 w-8 rounded-full" :src="`${s3Bucket}${memo.logo}`" alt="" />
          </span>
          {{ memo.company_name }}
        </div>

        <!-- <div class="relative">
          <h4 class="font-medium text-[18px] leading-[21.33px] text-center mb-3">
            One pager content
          </h4>
          <p class="text-[16px] leading-[24px] text-greyText text-center">
            This memo contains a concise expression of this startup’s unique value
            proposition.
          </p>
        </div> -->
      </div>
      <div class="right w-full">
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="company-summary"
            >Company Summary</label
          >
          <!-- <textarea
            id="company-summary"
            name="companySummary"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.company_summary"
            @blur="updateSummary"
          /> -->
            <WYSIWYGField v-model="data.company_summary" />

        </div>
        <!-- <div class="relative mb-6">
          <label
            class="font-Rubik text-greyText text-sm font-normal"
            for="team-details"
            >Team Details</label
          >
            <WYSIWYGField v-model="data.teamDetails" :isEditable="false" />
        </div> -->

        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="market-opportunity"
            >Market Opportunity</label
          >
            <WYSIWYGField v-model="data.market_opportunity" />

          <!-- <textarea
            id="market-opportunity"
            name="market-opportunity"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.market_opportunity"
          /> -->
          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Market opportunity')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.market_opportunity_docs"
            :key="index"
          >
            <span
              class="selected-file py-[5px] px-[10px] bg-black rounded-[4px] text-white text-[14px] leading-[20px] mr-2 relative"
              >
              {{ doc.file_name }}
              <!-- <span class="delete-file w-[20px] h-[20px] bg-white text-black border-2 border-black font-medium rounded-full opacity-0 absolute right-[-7px] top-[-7px] flex items-center justify-center cursor-pointer">
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.81192 0.748576C10.1536 0.406867 10.7076 0.406867 11.0494 0.748576C11.3911 1.09028 11.3911 1.6443 11.0494 1.98601L2.3873 10.6481C2.04559 10.9898 1.49157 10.9898 1.14986 10.6481C0.808152 10.3064 0.808153 9.75234 1.14986 9.41063L9.81192 0.748576Z" fill="black"/>
                  <path d="M11.0494 9.41063C11.3911 9.75234 11.3911 10.3064 11.0494 10.6481C10.7076 10.9898 10.1536 10.9898 9.81192 10.6481L1.14986 1.98601C0.808153 1.6443 0.808153 1.09028 1.14986 0.748575C1.49157 0.406866 2.04559 0.406866 2.3873 0.748575L11.0494 9.41063Z" fill="black"/>
                </svg>
              </span> -->
            </span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="customer-pricing"
            >Customer & Pricing</label
          >
          <!-- <textarea
            id="customer-pricing"
            name="customer-pricing"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.customer_and_pricing"
          /> -->
            <WYSIWYGField v-model="data.customer_and_pricing" />

          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Customer and pricing')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.customer_and_pricing_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="product"
            >Product</label
          >
          <!-- <textarea
            id="product"
            name="product"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.product"
          /> -->
            <WYSIWYGField v-model="data.product" />
          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Product')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.product_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="customer-retention"
            >Customers Acquisition & Retention</label
          >
          <!-- <textarea
            id="customer-retention"
            name="customer-retention"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.acquisition_and_retention"
          /> -->
            <WYSIWYGField v-model="data.acquisition_and_retention" />
          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Acquisition and retention')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.acquisition_and_retention_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="competition"
            >Competition</label
          >
          <!-- <textarea
            id="competition"
            name="competition"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.competition"
          /> -->
            <WYSIWYGField v-model="data.competition" />

          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Competition')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.competition_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="summary-financials"
            >Summary Financials</label
          >
          <!-- <textarea
            id="summary-financials"
            name="summary-financials"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.summary_financials"
          /> -->
            <WYSIWYGField v-model="data.summary_financials" />

          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Summary financials')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.summary_financials_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="deal"
            >Deal</label
          >
          <!-- <textarea
            id="deal"
            name="deal"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.deal"
          /> -->
            <WYSIWYGField v-model="data.deal" />

          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Deal')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.deal_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="outcomes-analysis"
            >Outcomes Analysis</label
          >
          <!-- <textarea
            id="outcomes-analysis"
            name="outcomes-analysis"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.outcomes_analysis"
          /> -->
            <WYSIWYGField v-model="data.outcomes_analysis" />

          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Outcomes analysis')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.outcomes_analysis_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="conclusion"
            >Conclusion</label
          >
          <!-- <textarea
            id="conclusion"
            name="conclusion"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.conclusion"
          /> -->
            <WYSIWYGField v-model="data.conclusion" />
          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Conclusion')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.conclusion_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative mb-6">
          <label
            class="font-Rubik font-medium text-[18px] leading-[21.33px] mb-3 block"
            for="appendix"
            >Appendix</label
          >
          <!-- <textarea
            id="appendix"
            name="appendix"
            type="text"
            rows="4"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Relevant content pulled from the database will be displayed here..."
            style="transition: 'all .15s ease'"
            v-model="data.appendix"
          /> -->
            <WYSIWYGField v-model="data.appendix" />

          <div class="add-document flex flex-col mt-3">
            <span class="text-[12px] leading-[14.22px] text-greyText mb-2"
              >ADD DOCUMENT (Optional)</span
            >
            <button
              @click="addDocumentToComment('Appendix')"
              class="border-black border-[1px] text-[14px] leading-[20px] font-medium text-center max-w-[160px] w-full py-2 rounded-[2px]"
            >
              <span class="mr-2 text-[18px] font-medium">+</span>
              Add Documents
            </button>
          </div>
          <div
            class="relative w-full flex items-center flex-wrap mt-3"
            v-for="(doc, index) in data.appendix_docs"
            :key="index"
          >
            <span
              class="py-[5px] px-[10px] bg-black rounded-[4px] text-white tex-[14px] leading-[20px] mr-2"
              >{{ doc.file_name }}</span
            >
          </div>
        </div>
        <div class="relative flex justify-end w-full my-12">
          <!-- <button
            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[12px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
            @click="onSaveDraft"
          >
            Save draft
          </button> -->
          <button
            @click="onSubmit"
            class="flex items-center justify-center bg-black text-white rounded-[6px] text-[14px] font-Rubik px-[28px] py-[12px] md:max-w-[max-content] w-full outline-none focus:outline-none disabled:opacity-50"
          >
            <span :class="submitloading ? 'mr-2' : 'mr-0'" class="text-white"
              >Save memo</span
            >
            <svg
              v-if="submitloading"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              style="background: none; display: block; shape-rendering: auto"
              width="20px"
              height="20px"
              viewBox="0 0 100 100"
              preserveAspectRatio="xMidYMid"
            >
              <circle
                cx="50"
                cy="50"
                fill="none"
                stroke="#ffffff"
                stroke-width="10"
                r="35"
                stroke-dasharray="164.93361431346415 56.97787143782138"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  repeatCount="indefinite"
                  dur="1s"
                  values="0 50 50;360 50 50"
                  keyTimes="0;1"
                ></animateTransform>
              </circle>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <Modal v-if="data.documentModal">
      <div class="bg-white rounded-[2px] py-[40px] px-[48px] relative w-[480px]">
        <button
          @click.prevent="closeModal"
          class="close absolute right-[20px] top-[20px]"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#0D0D0D"
            />
          </svg>
        </button>
        <div v-if="currentActiveReview === 1">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`market-opportunity-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                  <!-- <span class="text-[12px] leading-[20px] text-greyText">{{Helpers.getFileExtension(file.file_name)}}</span> -->
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.market_opportunity_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 2">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`customer-pricing-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.customer_and_pricing_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 3">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`product-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.product_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 4">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`customer-retention-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.acquisition_and_retention_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 5">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`competition-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.competition_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 6">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`team-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.summary_financials_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 7">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`summary-financials-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.deal_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 8">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`deal-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.outcomes_analysis_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 9">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`outcomes-analysis-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.conclusion_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>
        <div v-if="currentActiveReview === 10">
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Add document(s) to your response
          </h3>
          <hr />
          <div class="mt-4 w-full">
            <label for="search" class="sr-only">Search Documents</label>
            <div class="relative text-black">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-4 w-4 text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                id="search"
                name="search"
                class="block w-full pl-10 pr-3 py-3 rounded-md text-[14px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm border-none focus:outline-none focus:ring-0"
                placeholder="Search documents"
                type="text"
                v-model="searchParam"
              />
            </div>
          </div>
          <div class="mt-4 mb-4 h-[350px] overflow-auto">
            <div
              v-for="(file, index) in filteredCompanyFiles()"
              :key="index"
              class="mt-3 mb-3 relative flex items-start p-6 border rounded"
            >
              <div class="mr-5">
                <img
                  :src="
                    require(`../../assets/files/${Helpers.getFileIcon(
                      file.mime_type
                    )}.png`)
                  "
                  class="w-8"
                />
              </div>
              <div class="min-w-0 flex-1 text-sm">
                <div class="flex flex-col">
                  <label
                    :for="`conclusion-${file.id}`"
                    class="text-[14px] leading-[20px] font-Rubik"
                    >{{ file.file_name }}</label
                  >
                </div>
              </div>
              <div class="ml-3 flex items-center my-auto h-5">
                <input
                  :id="`memo-${file.id}`"
                  :name="`memo-${file.id}`"
                  type="checkbox"
                  class="focus:ring-black h-4 w-4 text-black border-gray-300 rounded"
                  v-model="data.appendix_docs"
                  :value="file"
                />
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button
              @click="addDocuments()"
              class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50"
            >
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Add Files</span>
              <svg
                v-if="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="
                  margin: auto;
                  background: none;
                  display: block;
                  shape-rendering: auto;
                "
                width="20px"
                height="20px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  fill="none"
                  stroke="#ffffff"
                  stroke-width="10"
                  r="35"
                  stroke-dasharray="164.93361431346415 56.97787143782138"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                  ></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </div>

      </div>
    </Modal>
  </main>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, reactive, ref } from 'vue'
import Breadcrumb from '@/components/BreadCrumb.vue'
import useVuelidate from '@vuelidate/core'
import { required, helpers, minLength, alpha } from '@vuelidate/validators'
import Modal from '@/components/Modal.vue'
import Helpers from '@/utils/helpers'
import MemoService from '@/services/memo.service'
import { useStore } from 'vuex'
import CompanyService from '@/services/company.service'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import WYSIWYGField from '@/components/WYSIWYGField.vue'

export default {
  components: {
    Breadcrumb,
    Modal,
    MenuItems,
    MenuItem,
    MenuButton,
    Menu,
    WYSIWYGField
  },
  setup () {
    const s3Bucket = process.env.VUE_APP_ORIGINS_S3_BUCKET
    const memoBaseUrl = process.env.VUE_APP_MEMO_URL
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const companyID = ref({})
    const memo = ref({})
    const textCopied = ref(false)
    const submitloading = ref(false)
    const loading = ref(false)
    const slug = ref(null)
    // eslint-disable-next-line camelcase
    const doc_ids = ref([])
    // const companyData = computed(() => store.state.app.company)
    const companyFiles = ref([])

    // const getCompany = (id) => {
    //   return companyData.value.filter(company => company.id === id)
    // }
    // const upDateList = () => {
    //   routeID.value = route.params.id
    //   const company = getCompany(route.params.id)
    //   companyID.value.breadcrumbList = company[0].company_name
    //   companyID.value.route = route.path.split('/')[1]
    // }

    const data = reactive({
      company_id: null,
      market_opportunity: null,
      market_opportunity_docs: [],
      customer_and_pricing: null,
      customer_and_pricing_docs: [],
      product: null,
      product_docs: [],
      acquisition_and_retention: null,
      acquisition_and_retention_docs: [],
      competition: null,
      competition_docs: [],
      company_summary: null,
      team: [],
      teamDetails: null,
      summary_financials: null,
      summary_financials_docs: [],
      deal: null,
      deal_docs: [],
      outcomes_analysis: null,
      outcomes_analysis_docs: [],
      conclusion: null,
      conclusion_docs: [],
      appendix: null,
      appendix_docs: [],
      modalOpen: false,
      documentModal: false,
      slug: null,
      filesAvailable: false
    })

    const rules = computed(() => ({
      company_summary: { required },
      team: {
        $each: helpers.forEach({
          name: { required, minLengthValue: minLength(3), alpha },
          role: { required, minLengthValue: minLength(3) }
        })
      },
      market_opportunity: { required },
      customer_and_pricing: { required },
      product: { required },
      acquisition_and_retention: { required },
      competition: { required },
      summary_financials: { required },
      deal: { required },
      outcomes_analysis: { required },
      conclusion: { required },
      appendix: { required }
    }))

    const v$ = useVuelidate(rules, data)

    const fetchMemo = async (id) => {
      try {
        const response = await MemoService.getMemobyId(id)
        if (response.status === 200 && response.data.status === 'success') {
          return response.data.data
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    const getCompanyFiles = async (id) => {
      try {
        const response = await CompanyService.fetchAllCompanyfiles(id)
        if (response.status === 200 && response.data.status === 'success') {
          companyFiles.value = response.data.data
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    const upDateList = async () => {
      // routeID.value = route.params.id
      const mem = await fetchMemo(route.params.id)
      getCompanyFiles(mem.company_id)
      companyID.value.breadcrumbList = mem.company_name
      companyID.value.route = route.path.split('/')[1]

      data.company_id = mem.company_id
      data.company_summary = mem.company_summary
      data.team = mem.team
      data.market_opportunity = mem.market_opportunity
      data.market_opportunity_docs = mem.market_opportunity_docs
      data.customer_and_pricing = mem.customer_and_pricing
      data.customer_and_pricing_docs = mem.customer_and_pricing_docs
      data.product = mem.product
      data.product_docs = mem.product_docs
      data.acquisition_and_retention = mem.acquisition_and_retention
      data.acquisition_and_retention_docs = mem.acquisition_and_retention_docs
      data.competition = mem.competition
      data.competition_docs = mem.competition_docs
      data.summary_financials = mem.summary_financials
      data.summary_financials_docs = mem.summary_financials_docs
      data.deal = mem.deal
      data.deal_docs = mem.deal_docs
      data.outcomes_analysis = mem.outcomes_analysis
      data.outcomes_analysis_docs = mem.outcomes_analysis_docs
      data.conclusion = mem.conclusion
      data.conclusion_docs = mem.conclusion_docs
      data.appendix = mem.appendix
      data.appendix_docs = mem.appendix_docs
      slug.value = mem.slug

      memo.value = mem
    }
    const addNewField = (arr) => {
      if (arr === null) {
        data.team = [{
          name: '',
          role: ''
        }]
      } else {
        arr.push({
          name: '',
          role: ''
        })
      }
    }
    const removeField = (arr, index) => {
      arr.splice(index, 1)
    }
    onMounted(() => {
      upDateList()
    })
    const openModal = () => {
      data.modalOpen = !data.modalOpen
    }
    const closeModal = () => {
      data.modalOpen = false
      data.documentModal = false
      doc_ids.value = []
      textCopied.value = false
      searchParam.value = ''
    }
    const copyToClipboard = (text) => {
      const cb = navigator.clipboard
      cb.writeText(text).then(() => {
        textCopied.value = true
      })
    }
    const createSharableLink = (slug) => {
      openModal()
      data.slug = `${process.env.VUE_APP_MEMO_URL}/${slug}`
    }
    const openDocModal = () => {
      data.documentModal = !data.documentModal
    }

    const currentActiveReview = ref()
    const addDocumentToComment = (slug) => {
      switch (slug) {
        case 'Market opportunity':
          currentActiveReview.value = 1
          openDocModal()
          break
        case 'Customer and pricing':
          openDocModal()
          currentActiveReview.value = 2
          break
        case 'Product':
          openDocModal()
          currentActiveReview.value = 3
          break
        case 'Acquisition and retention':
          openDocModal()
          currentActiveReview.value = 4
          break
        case 'Competition':
          openDocModal()
          currentActiveReview.value = 5
          break
        case 'Summary financials':
          openDocModal()
          currentActiveReview.value = 6
          break
        case 'Deal':
          openDocModal()
          currentActiveReview.value = 7
          break
        case 'Outcomes analysis':
          openDocModal()
          currentActiveReview.value = 8
          break
        case 'Conclusion':
          openDocModal()
          currentActiveReview.value = 9
          break
        case 'Appendix':
          openDocModal()
          currentActiveReview.value = 10
          break

        default:
      }
      return currentActiveReview
    }
    const addDocuments = async () => {
      // const payload = {
      //   market_opportunity: data.market_opportunity,
      //   market_opportunity_docs: data.market_opportunity_docs,
      //   customer_and_pricing: data.customer_and_pricing,
      //   customer_and_pricing_docs: data.customer_and_pricing_docs,
      //   product: data.product,
      //   product_docs: data.product_docs,
      //   acquisition_and_retention: data.acquisition_and_retention,
      //   acquisition_and_retention_docs: data.acquisition_and_retention_docs,
      //   competition: data.competition,
      //   competition_docs: data.competition_docs,
      //   summary_financials: data.summary_financials,
      //   summary_financials_docs: data.summary_financials_docs,
      //   deal: data.deal,
      //   deal_docs: data.deal_docs,
      //   outcomes_analysis: data.outcomes_analysis,
      //   outcomes_analysis_docs: data.outcomes_analysis_docs,
      //   conclusion: data.conclusion,
      //   conclusion_docs: data.conclusion_docs,
      //   appendix: data.appendix,
      //   appendix_docs: data.appendix_docs
      // }
      closeModal()
      // try {
      //   loading.value = true
      //   const payload = {
      //     collection_ids: collection_ids.value.map((str) => ({ id: str })),
      //     company_ids: [{ id: route.params.id }]
      //   }
      //   const response = await CollectionService.addCompanytoCollection(payload)
      //   if (response.status === 200 && response.data.status === 'success') {
      //     loading.value = false
      //     data.collection = true
      //   }
      // } catch (e) {
      //   loading.value = false
      //   Helpers.processError(e, store, router)
      // }
    }
    const searchParam = ref('')
    const filteredCompanyFiles = () => {
      return companyFiles.value.filter((file) => file.file_name.toLowerCase().includes(searchParam.value.toLowerCase()))
    }
    const updateSummary = async () => {
      const id = data.company_id
      const payload = {
        company_summary: data.company_summary
      }
      try {
        const response = await CompanyService.updateCompanySummary(id, payload)
        if (response.status === 200) {
          // const res = response.data
          Helpers.processRiskSuccess(response, store, response.data.message)
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    const onSubmit = async () => {
      updateSummary()
      const payload = {
        market_opportunity: data.market_opportunity,
        market_opportunity_docs: data.market_opportunity_docs,
        customer_and_pricing: data.customer_and_pricing,
        customer_and_pricing_docs: data.customer_and_pricing_docs,
        product: data.product,
        product_docs: data.product_docs,
        acquisition_and_retention: data.acquisition_and_retention,
        acquisition_and_retention_docs: data.acquisition_and_retention_docs,
        competition: data.competition,
        competition_docs: data.competition_docs,
        summary_financials: data.summary_financials,
        summary_financials_docs: data.summary_financials_docs,
        deal: data.deal,
        deal_docs: data.deal_docs,
        outcomes_analysis: data.outcomes_analysis,
        outcomes_analysis_docs: data.outcomes_analysis_docs,
        conclusion: data.conclusion,
        conclusion_docs: data.conclusion_docs,
        appendix: data.appendix,
        appendix_docs: data.appendix_docs
      }
      const sanitizedPayload = JSON.parse(JSON.stringify(payload))
      Object.keys(sanitizedPayload).forEach(key => {
        if (sanitizedPayload[key] === null || sanitizedPayload[key].length === 0) {
          delete sanitizedPayload[key]
        }
      })
      try {
        const id = route.params.id
        const response = await MemoService.updateMemo(id, sanitizedPayload)
        if (response.status === 200 && response.data.status === 'success') {
          const res = response.data
          Helpers.processNotification(res, store, router)
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    return {
      data,
      companyID,
      memo,
      v$,
      s3Bucket,
      openModal,
      closeModal,
      createSharableLink,
      copyToClipboard,
      textCopied,
      submitloading,
      loading,
      addDocumentToComment,
      openDocModal,
      doc_ids,
      Helpers,
      currentActiveReview,
      addDocuments,
      companyFiles,
      searchParam,
      filteredCompanyFiles,
      onSubmit,
      memoBaseUrl,
      addNewField,
      removeField,
      updateSummary
    }
  }
}
</script>

<style>
.selected-file:hover > .delete-file {
  opacity: 1 !important;
}
</style>
